"use strict";
/* @ngInject */
function instructorsService(userService, API_URL, $http, $q) {
    var makeInstructorDisplayName = function (instructor) {
        var name = instructor.name;
        var middle = name.middleName ? name.middleName + " " : "";
        instructor.name.displayName = name.firstName + " " + middle + name.lastName;
    };
    return function (tenantId) {
        return $http.get(API_URL.instructors + "?query={\"tenantId\": \"" + tenantId + "\"}").then(function (response) {
            response.data.forEach(makeInstructorDisplayName);
            return response.data;
        }, function (errorResponse) {
            if (errorResponse && errorResponse.status === 404) {
                return [];
            }
            else {
                return $q.reject(errorResponse);
            }
        });
    };
}
exports.instructorsService = instructorsService;



/** WEBPACK FOOTER **
 ** ./app/common/instructors/instructors.service.ts
 **/